module.exports = __webpack_public_path__ + "static/media/fil-r.da397aa0.png";